import React, { useContext, useEffect, useState } from "react"
import { Spinner } from "react-bootstrap"
import { GetApi } from "../../../../../../api/api"
import { FCAttributeType } from "../../../../../../api/generated/QuadriConfigurationApi"
import { useHistory, useParams } from "react-router-dom"
import { FeatureCatalogContext } from "../../../../../../features/FeatureCatalogViewer/FeatureCatalogProvider"
import "./attributeProperties.scss"
import AttributePropertyItem from "./AttributePropertyItem"
import useQuery from "../../../UseQuery"

const AttributeProperties = () => {
  const [properties, setProperties] = useState(null as FCAttributeType | null)
  const [isLoading, setIsLoading] = useState(false)
  const [hover, setHover] = useState(false)

  const context = useContext(FeatureCatalogContext)
  const history = useHistory()
  const { catalog, type } = useParams<{ catalog: string; type: string; pid: string }>()
  const language = useQuery().get("language")

  useEffect(() => {
    const getAttributeProperties = () => {
      setIsLoading(true)
      if (context.atId !== null) {
        GetApi().then((api) => {
          api.getAnyAttributeType(catalog, context.atId!, language).then((response) => {
            setProperties({
              ...response
            })
            if (type === "attributeType") {
              context.setTypeDisplayName(response.name)
            }
          })
        })
        setIsLoading(false)
      }
    }

    getAttributeProperties()
  }, [context.atId, language])

  const onClose = () => {
    context.setAtId(null)
  }

  const onClick = () => {
    context.setAtId(null)
    context.setTypeDisplayName(properties?.associationContent?.featureType?.featureTypeName!)
    context.updateHistory(
      history,
      catalog,
      "featureType",
      "" + properties?.associationContent?.featureType?.featureTypeId!
    )
  }

  const setHoverTrue = () => {
    setHover(true)
  }

  const setHoverFalse = () => {
    setHover(false)
  }

  const convertListToString = () => {
    return properties?.legalValues
      ?.map((item) => {
        return item.value
      })
      .join(", ")
  }

  return (
    <div id={type === "attributeType" ? "withoutPadding" : "withPadding"}>
      {isLoading ? <Spinner className="spinner" animation="border" role="status" variant="primary" /> : <></>}
      <table
        className="attributeTable table-borderless"
        id={type === "attributeType" ? "attributeSelected" : "attributeInList"}
      >
        <tbody>
          <tr>
            <td id="headerInTable" className="card-subtitle-2" colSpan={4}>
              Attribute properties: <span style={{ fontWeight: "normal" }}>PID </span>{" "}
              <span style={{ color: "black" }}>{properties?.id}</span>{" "}
              {type === "attributeType" ? (
                <></>
              ) : (
                <a type="button" className="close" onClick={onClose} aria-label="Close">
                  <i className="modus-icons">close</i>
                </a>
              )}
            </td>
          </tr>
          <tr>
            <td className="card-subtitle-1">Datatype</td>
            <td className="attributeData">
              {/* if dataType is Measure display measureType instead */}
              {properties?.dataType === "Measure" ? properties?.measureType : properties?.dataType}
            </td>
            {properties?.associationContent?.featureType ? (
              <td className="card-subtitle-1">Associated feature type</td>
            ) : (
              <></>
            )}
            {properties?.associationContent?.featureType ? (
              <td
                className="attributeData"
                id={hover ? "hover" : "notHover"}
                onClick={onClick}
                onMouseOver={setHoverTrue}
                onMouseLeave={setHoverFalse}
              >
                {properties.associationContent.featureType.featureTypeName}
              </td>
            ) : (
              <></>
            )}
          </tr>
          <tr>
            <td className="card-subtitle-1">Mandatory</td>
            <td className="attributeData">{properties?.mandatory ?? "False"}</td>
            <AttributePropertyItem header="Default value" value={properties?.defaultValue} />
          </tr>
          <tr>
            <AttributePropertyItem header="Min value" value={properties?.minValue} />
            <AttributePropertyItem header="Max value" value={properties?.maxValue} />
          </tr>
          <tr>
            <AttributePropertyItem header="Decimal" value={properties?.numberOfDecimals} />
            {properties?.hasLegalValues ? (
              <AttributePropertyItem header="Dropdown values" value={convertListToString()} />
            ) : (
              <></>
            )}
          </tr>
          <tr>
            <AttributePropertyItem header="Short name" value={properties?.shortName} />
          </tr>
          <tr>
            {properties?.dataType === "Locational" ? (
              <AttributePropertyItem header="Type of extent" value={properties?.locationalContent?.typeOfExtent} />
            ) : (
              <></>
            )}
          </tr>
          <tr>
            <AttributePropertyItem header="Description" value={properties?.description} />
          </tr>
        </tbody>
      </table>
    </div>
  )
}

export default AttributeProperties
